import { render, staticRenderFns } from "./Sensitivity.vue?vue&type=template&id=277a715c&scoped=true&"
import script from "./Sensitivity.vue?vue&type=script&lang=ts&"
export * from "./Sensitivity.vue?vue&type=script&lang=ts&"
import style0 from "./Sensitivity.vue?vue&type=style&index=0&id=277a715c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277a715c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('277a715c')) {
      api.createRecord('277a715c', component.options)
    } else {
      api.reload('277a715c', component.options)
    }
    module.hot.accept("./Sensitivity.vue?vue&type=template&id=277a715c&scoped=true&", function () {
      api.rerender('277a715c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Settings/Sensitivity.vue"
export default component.exports